var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSmileEmoji(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1753_78884)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.2501 42.4319C2.60964 42.4133 -6.76667 19.7753 6.40104 6.58274C14.2177 -1.56311 28.2827 -1.56442 36.0993 6.58307C49.2669 19.7769 39.8895 42.4143 21.2501 42.4319ZM21.2501 2.23665C10.6658 2.23665 2.05487 10.8476 2.05487 21.4319C3.10929 46.8971 39.3949 46.8897 40.4454 21.4318C40.4454 10.8477 31.8344 2.23665 21.2501 2.23665Z",
    fill: "url(#paint0_linear_1753_78884)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2501 2.23665C10.6658 2.23665 2.05487 10.8476 2.05487 21.4319C3.10929 46.8971 39.3949 46.8897 40.4454 21.4318C40.4454 10.8477 31.8344 2.23665 21.2501 2.23665Z",
    fill: "url(#paint1_linear_1753_78884)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7205 17.7234C16.2222 17.7234 15.8182 17.3194 15.8182 16.821C15.8182 15.6337 14.8523 14.6678 13.665 14.6678C12.4776 14.6678 11.5117 15.6337 11.5117 16.821C11.465 18.0169 9.75453 18.0185 9.70703 16.821C9.92466 11.5699 17.4064 11.5722 17.6229 16.821C17.6229 17.3194 17.2189 17.7234 16.7205 17.7234Z",
    fill: "#2D2D2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7586 17.7234C31.2603 17.7234 30.8563 17.3194 30.8563 16.821C30.8563 15.6337 29.8904 14.6678 28.703 14.6678C27.5157 14.6678 26.5498 15.6337 26.5498 16.821C26.503 18.0169 24.7926 18.0185 24.7451 16.821C24.9627 11.5699 32.4445 11.5722 32.661 16.821C32.661 17.3194 32.257 17.7234 31.7586 17.7234Z",
    fill: "#2D2D2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1812 26.2986H12.4858C12.0654 26.2986 11.7246 26.6449 11.7246 27.072C11.7246 31.7528 16.0351 35.561 21.3335 35.561C26.632 35.561 30.9425 31.7528 30.9425 27.072C30.9424 26.6449 30.6017 26.2986 30.1812 26.2986Z",
    fill: "#2D2D2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1309 33.6304C16.8936 31.0618 18.9451 29.76 21.2493 29.76C23.6275 29.76 25.6509 31.0235 27.3948 33.6071C23.6371 36.7772 18.8935 36.7857 15.1309 33.6304Z",
    fill: "#FF0000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1753_78884",
    x1: 3.059,
    y1: 31.9465,
    x2: 39.4232,
    y2: 10.9319,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBB34D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#ECB64D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#EEC04F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#F1CC51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3D652"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1753_78884",
    x1: 3.059,
    y1: 31.9465,
    x2: 39.4232,
    y2: 10.9319,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBB34D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#ECB64D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#EEC04F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#F1CC51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3D652"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1753_78884"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    fill: "white",
    transform: "translate(0.25 0.452393)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmileEmoji);
export default __webpack_public_path__ + "static/media/smile-emoji.114c386dedbfdb51e1dc66995e52c9fa.svg";
export { ForwardRef as ReactComponent };